import { useState, useEffect } from 'react'

import { 
    CardMedia,
    Divider,
    Grid,
    Box
} from '@mui/material';
import _ from 'lodash';

import CustomLayout from 'views/CustomLayout'
import CustomBreadcrumbs from "components/Breadcrumbs";
import Loader from 'components/Loader';
import axiosInstance from "configs/axiosConfig";
import { APIRouteConstants } from 'constants/routeConstants';
import { useSelector } from 'react-redux';

const About = ({ breadcrumbs }) => {
    const [loader, setLoader] = useState(false);
    const [aboutUs, setAboutUs] = useState();
    const webDetails = useSelector(state => state.webDetails);
    const { websiteInfo } = webDetails;
console.log("aboutus",(websiteInfo["about_us_images"]))
    const getAboutUs = async () => {
        setLoader(true)
        let res = await axiosInstance.get(APIRouteConstants.DASHBOARD.ABOUT_INFO);
        let { data, response } = res;

        if (data && data.about) {
            setAboutUs(data.about)
        }
        setLoader(false)
    }

    useEffect(() => {
        getAboutUs();
    }, []);

    const bgImage = require("../../assets/images/background.jpg");

    return (
        <CustomLayout>
            <Loader open={loader} />
            {/* <div
                style={{ 
                    // backgroundImage: `url(${_.get(websiteInfo, 'banner')})` 
                    backgroundImage: _.get(websiteInfo, 'banner', '') 
                        ? `url(${_.get(websiteInfo, 'banner')})`
                        : `url(${bgImage})`
                }}
                class="parallax">
                <div className="header-wrapper">
                    <span className="span-2">About Us</span>
                </div>
            </div> */}

<>
      {/* ✅ Desktop View */}
      <Box
        className="parallax"
        sx={{
          display: { xs: "none", sm: "none", md: "block" },
          backgroundImage: _.get(websiteInfo, "banner", "")
            ? `url(${_.get(websiteInfo, "banner")})`
            : `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="header-wrapper">
          <span className="span-2">About Us</span>
        </div>
      </Box>

      {/* ✅ Mobile View */}
      <Box
        sx={{
          display: { xs: "block", sm: "block", md: "none" },
          position: "relative",
        }}
      >
        <img
          src={
            _.get(websiteInfo, "banner", "")
              ? _.get(websiteInfo, "banner")
              : bgImage
          }
          alt="Banner"
          style={{ width: "100%", height: "auto", objectFit: "cover" }}
        />
        <div
          className="header-wrapper"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "white",
          }}
        >
          <span className="span-2">About Us</span>
        </div>
      </Box>
    </>
            <div className="content-container">
                <CustomBreadcrumbs list={breadcrumbs} name={"About"} />
                <Divider className="divider"/>
                <Grid container className="about-wrapper main-content-wrapper">
                    <Grid item xs={12} sm={12} md={12} lg={12} container direction="row" justifyContent="space-between" alignItems="center">
                        <Grid item xs={12} sm={12} md={12} lg={8}>
                        <div className='content-wrapper description' dangerouslySetInnerHTML={{__html: aboutUs}} />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={3} textAlign={'center'} sx={{width:"90%",margin:"auto"}} >
                        <CardMedia component={'img'} key={"about us image"} src={websiteInfo?.about_main_image} sx={{width:"100%",objectFit:"contain"}}/>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} mt={8}>
                        {websiteInfo && websiteInfo["about_us_images"]?.map((url, index) => (
                            <Grid item xs={4} sm={3} md={2.2} lg={1.5} key={index}>
                                <CardMedia sx={{width:"75%",objectFit:"contain"}} component="img" src={url} alt={`Image ${index + 1}`} />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </div>
        </CustomLayout>
    )
}

export default About
